import * as constants from './constants';

/* Get project credits */
export const getCredits = (projectId, callback) => ({
  type: constants.GET_CREDITS,
  projectId,
  callback
});

export const getCreditsSuccess = (projectId, credits) => ({
  type: constants.GET_CREDITS_SUCCESS,
  projectId,
  credits
});

export const getCreditsError = (projectId, error) => ({
  type: constants.GET_CREDITS_ERROR,
  projectId,
  error
});

/* Activate credit */
export const activateCredit = (projectId, instanceId, creditId, actions) => ({
  type: constants.ACTIVATE_CREDIT,
  projectId,
  instanceId,
  creditId,
  actions
});

export const activateCreditSuccess = (
  projectId,
  instanceId,
  creditId,
  credit
) => ({
  type: constants.ACTIVATE_CREDIT_SUCCESS,
  projectId,
  instanceId,
  creditId,
  credit
});

export const activateCreditError = (
  projectId,
  instanceId,
  creditId,
  error
) => ({
  type: constants.ACTIVATE_CREDIT_ERROR,
  projectId,
  instanceId,
  creditId,
  error
});

/* Schedule credit */
export const scheduleCredit = (
  projectId,
  instanceId,
  creditId,
  scheduleDate,
  actions
) => ({
  type: constants.SCHEDULE_CREDIT,
  projectId,
  instanceId,
  creditId,
  scheduleDate,
  actions
});

export const scheduleCreditSuccess = (
  projectId,
  instanceId,
  creditId,
  credit
) => ({
  type: constants.SCHEDULE_CREDIT_SUCCESS,
  projectId,
  instanceId,
  creditId,
  credit
});

export const scheduleCreditError = (
  projectId,
  instanceId,
  creditId,
  error
) => ({
  type: constants.SCHEDULE_CREDIT_ERROR,
  projectId,
  instanceId,
  creditId,
  error
});
